<mat-dialog-content>
    <h4 mat-card-title>Причина отказа от заявки</h4>
    <mat-dialog-content>
        <form class="flex-column" [formGroup]="rejectForm" (ngSubmit)="onSubmit()">
            <mat-form-field>
                <mat-label>Причина отказа</mat-label>
                <mat-select formControlName="rejectReason">
                    @for (status of enumService.enumToArr(RejectOrderStatusEnum); track status) {
                        <mat-option [value]="status">{{status}}</mat-option>
                    }
                </mat-select>
            </mat-form-field>

            <mat-form-field>
                <mat-label>Пояснение</mat-label>
                <textarea matInput formControlName="rejectDescription"></textarea>
            </mat-form-field>

            <div class="flex-column">
                <button class="mrb-1" mat-raised-button type="submit" [disabled]="!rejectForm.valid">Сохранить</button>
                <button id="reject" mat-raised-button type="button" (click)="onCancel()">Отмена</button>
            </div>
        </form>

    </mat-dialog-content>
</mat-dialog-content>
